import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import AddSiteDepartmentDialog from "./SiteDepartment/AddSiteDepartmentDialog";
import SiteWrapper from "components/Layouts/SiteWrapper";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { fetchSiteDetail } from "../../../../redux/siteDetail/actions";
import { getSiteDepartments } from "services/clients/sites/siteDepartments";
import SiteDepartmentsContent from "./SiteDepartmentsContent";
import { showError } from "../../../../redux/common/actions";
import { getLocalStorageData } from "helpers/utils";
import mainAccess from "helpers/access";
import { getSiteNavigationFromStorage } from "helpers/siteNavigation";

const SiteDepartmentsScreen = ({
	handlefetchSiteDetail,
	getError,
	siteDetails,
}) => {
	const { id, clientId } = useParams();
	const navigate = useNavigate();
	const [data, setData] = useState([]);
	const [modal, setModal] = useState({ add: false });
	const cancelFetch = useRef(false);
	const [isLoading, setIsLoading] = useState(true);
	const { role, isSiteUser, customCaptions, position, siteAppID } =
		getLocalStorageData("me");
	const dispatch = useDispatch();
	const { t } = useTranslation();

	const navigation = getSiteNavigationFromStorage(getLocalStorageData);
	
	const siteUserAccess =
		position?.[mainAccess.settingsAccess] !== "R" || !siteAppID;

	const fetchSiteDepartments = async () => {
		try {
			const response = await getSiteDepartments(id);
			if (cancelFetch.current) {
				return;
			}
			if (response.status) {
				setData(response.data);
				setIsLoading(false);
				return response;
			} else {
				throw new Error(response);
			}
		} catch (err) {
			setIsLoading(false);
			dispatch(
				showError(
					t("message.failedToFetchEntity", {
						entity: customCaptions?.departmentPlural,
					})
				)
			);
			return err;
		}
	};

	useEffect(() => {
		fetchSiteDepartments();
		// eslint-disable-next-line react-hooks/exhaustive-deps
		handlefetchSiteDetail(id, clientId);
		return () => {
			cancelFetch.current = true;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleCreateData = (item) => {
		const newData = [...data];

		newData.push(item);

		setData(newData);
	};

	return (
		<>
			<AddSiteDepartmentDialog
				open={modal.add}
				closeHandler={() => setModal(() => ({ add: false }))}
				createHandler={handleCreateData}
				siteID={id}
				getError={getError}
			/>
			<SiteWrapper
				current={customCaptions?.departmentPlural ?? t("entity.department", { count: 2 })}
				navigation={navigation}
				onNavClick={(urlToGo) =>
					navigate(`/app/clients/${clientId}/sites/${id}${urlToGo}`)
				}
				status=""
				lastSaved=""
				showAdd={siteUserAccess}
				onClickAdd={() => setModal((th) => ({ add: true }))}
			>
				<SiteDepartmentsContent
					data={data}
					setData={setData}
					isLoading={isLoading}
					getError={getError}
					isReadOnly={!siteUserAccess}
				/>
			</SiteWrapper>
		</>
	);
};

const mapStateToProps = ({ siteDetailData: { siteDetails } }) => ({
	siteDetails,
});

const mapDispatchToProps = (dispatch) => ({
	handlefetchSiteDetail: (siteId, clientId) =>
		dispatch(fetchSiteDetail(siteId, clientId)),
	getError: (msg) => dispatch(showError(msg)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SiteDepartmentsScreen);
